export enum LengthImperialUnitsEnum {
    // foot = "FOOT",
    // yard = "YARD",
    // mile = "MILE",
    inch = "INCH",
    foot = "FT",
    mile = "MI",
    //...
}
